import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

const messages = {
  en: {
    translation: {
      // menu
      Home: 'Home',
      Projetos: 'Projects',
      Sobre: 'About',
      Contato: 'Contact', 
      Certificados: 'Certificates',
      Experiencia: 'Professional Experience',
      Presente: 'Present',
      Educacao: 'Education',
      copy: 'Lpgoulart © All Rights Reserved',

      'tech resume': 'Know a little about the batteries I work with, among other technologies used in the market that I have contact with',
      'projetcs resume': 'See some of the projects I developed during my time as a Frontend developer, including some personal projects for study',
      'cert resume': 'Online course certificates, participation in lectures and project presentations',

      Titulo: 'Title',
      'Inglês': 'English',
      'Português': 'Portuguese',
      'Espanhol': 'Spanish',
      oi: 'Hello',
      Techs: 'Techs',

      'aboutme': `Hello, My name is Leonardo Goulart, I am graduated in Mechatronics Technician from the Nokia Foundation (2015) and currently I am bachelor in Information Technology from the Federal University of Rio Grande do Norte - UFRN. I'm a developer with a focus on Frontend. I like to develop individual projects in my free time to practice my knowledge and improve my skills. I have a passion for frontend development, an area in which I work and gradually study backend with NodeJs in order to develop more robust applications in the future. I have experience with:`,


      'about html': "The HTML language is the language for writing web pages. HTML is the acronym for HyperText Markup Language. Being a hypertext language means being able to write linked pages (containing links between pages; when a link is activated, another page must be displayed). Being a markup language means that the page is built from symbols used to mark how the page's content should be presented.",
      'about node': 'Node.js can be defined as a server-side Javascript execution environment. This means that with Node.js it is possible to create Javascript applications to run as a standalone application on a machine, not depending on a browser for execution, as we are used to.',
      'about git': 'Github is a web service that offers several extra features applied to git. In short, you can use github for free to host your personal projects.',
      'about less': 'Less (which stands for Leaner Style Sheets) is a backwards-compatible language extension for CSS. This is the official documentation for Less, the language and Less.js, the JavaScript tool that converts your Less styles to CSS styles.',
      'about css': '',
      'about js': '',
      'about npm': '',
      'about yarn': '',
      'about react': '',
      'about vue': '',
      'about angular': '',
      'about native': '',
      'about bootstrap': '',
      'about figma': '',
      'about gitlab': '',
      'about wordpress': '',
      'about apexchart': '',
      'about vscode': '',
      'about python': '',
      'about antd': '',
      'about ubuntu': '',
      'about windows': '',
    }
  },
  pt: {
    translation: {
      // Menu
      Home: 'Home',
      Projetos: 'Projetos',
      Sobre: 'Sobre',
      Contato: 'Contato',
      Certificados: 'Certificados',
      Experiencia: 'Experiência Profissional',
      Presente: 'Atualmente',
      Educacao: 'Educação',
      copy: 'Lpgoulart © Todos os direitos reservados',


      'tech resume': 'Conheça um pouco das stacks com as quais eu trabalho/trabalhei, dentre outras tecnologias usadas no mercado que tenho contato',
      'projetcs resume': 'Veja alguns dos projetos que desenvolvi ao longo do meu tempo como desenvolvedor Frontend, incluso alguns projetos pessoais para estudo',
      'cert resume': 'Certificados de cursos online, participações em palestras e apresentações de projetos',


      Titulo: 'Titulo',
      'Inglês': 'Inglês',
      'Português': 'Português',
      'Espanhol': 'Espanhol',
      oi: 'iaeeee',
      Techs: 'Tecnologias',

      'aboutme': `Olá, Meu nome é Leonardo Goulart, sou formado como Técnico em Mecatrônica pela Fundação Nokia de Ensino ( 2015 ) e atualmente bacharelando em Tecnologia da Informação pela Universidade Federal do Rio Grande do Norte - UFRN. Sou desenvolvedor com foco no Frontend. Gosto de desenvolver projetos avulsos no tempo livre para praticar meus conhecimentos e aprimorar minhas habilidades. Tenho paixão pelo desenvolvimento frontend, área na qual atuo e estudo aos poucos backend com NodeJs para poder desenvolver aplicações mais robustas no futuro. Tenho experiência com:`,


      'about html': 'A linguagem HTML é a linguagem para a escrita de páginas Web. HTML é o acrônimo de HyperText Markup Language (Linguagem de Marcação de HiperTexto). Ser uma linguagem de hipertexto significa ser capaz de escrever páginas interligadas (contendo ligações entre as páginas; quando uma ligação é ativada, outra página deve ser apresentada). Ser uma linguagem de marcação significa que a página é construída a partir de símbolos utilizados para marcar como o conteúdo da página deverá ser apresentado.',
      'about node': 'O Node.js pode ser definido como um ambiente de execução Javascript server-side. Isso significa que com o Node.js é possível criar aplicações Javascript para rodar como uma aplicação standalone em uma máquina, não dependendo de um browser para a execução, como estamos acostumados.',
      'about git': 'O Github é um serviço web que oferece diversas funcionalidades extras aplicadas ao git. Resumindo, você poderá usar gratuitamente o github para hospedar seus projetos pessoais.',
      'about less': 'Less (que significa Leaner Style Sheets) é uma extensão de linguagem compatível com versões anteriores do CSS. Esta é a documentação oficial para Less, a linguagem e Less.js, a ferramenta JavaScript que converte seus estilos Less em CSS.',
      'about css': '',
      'about js': '',
      'about npm': '',
      'about yarn': '',
      'about react': '',
      'about vue': '',
      'about angular': '',
      'about native': '',
      'about bootstrap': '',
      'about figma': '',
      'about gitlab': '',
      'about wordpress': '',
      'about apexchart': '',
      'about vscode': '',
      'about python': '',
      'about antd': '',
      'about ubuntu': '',
      'about windows': '',

    }
  },
  es: {
    translation: {
      // Menu 
      Home: 'Home',
      Projetos: 'Projects',
      Sobre: 'Sobre',
      Contato: 'Contato',

      Titulo: 'Capitulo',
      'Inglês': 'Ingles',
      'Português': 'Potugues',
      'Espanhol': 'Espanhol',
      oi: 'ola'
    }
  }
}

i18n.use(initReactI18next).init({
  resources: messages,
  lng: 'pt',
  keySeparator: false,
  interpolation: {
    escapeValue: false
  }
})

export default i18n
